import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { collection, doc, getDoc, getDocs, query } from "firebase/firestore";
import { db } from "../config/firebase";
import { Button } from "../components/Button";
import { ButtonBg } from "../components/ButtonBg";
import { Stars } from "../components/Stars";
import { Loading } from "../components/Loading";
import { Search } from "../components/Search";
import { KeypointSwip } from "../components/KeypointSwip";

export const BooksId = () => {
  const [book, setBook] = useState(null);
  const [keypoints, setKeypoints] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const { id } = useParams();
  const bookDocRef = doc(db, "Books", id);
  const keypointsQuery = query(collection(bookDocRef, "keypoints"));

  const toggleShowMore = () => {
    setShowMore((prevShowMore) => !prevShowMore);
  };

  const bookDescription = showMore
    ? book?.description
    : book?.description.slice(0, 200);

  useEffect(() => {
    const getBooks = async () => {
      try {
        const bookData = await getDoc(bookDocRef);
        setBook(bookData.data());
        const keypointsSnapshot = await getDocs(keypointsQuery);
        const keypointsData = keypointsSnapshot.docs.map((doc) => doc.data());
        const sortByOrder = keypointsData.sort((a, b) => a.order - b.order);
        setKeypoints(sortByOrder);
      } catch (error) {
        console.log("error____ ", error);
      }
    };
    getBooks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFavorite = () => {
    console.log("add favorite");
  };

  return (
    <>
      {!book ? (
        <div className="flex">
          <Loading />
        </div>
      ) : (
        <div className="flex flex-col p-5 md:p-10 lg:flex-row">
          <div className="px-5 md:hidden">
            <Search />
          </div>
          <div className="mt-10 px-5 sm:flex sm:justify-center sm:flex-col lg:block lg:mt-0 lg:pt-5 lg:w-1/4">
            {book?.imageUrl[0] ? (
              <img
                className="h-[420px] w-full object-contain bg-gray-100 mb-10 flex justify-center items-center sm:rounded-xl lg:max-w-72"
                src={book?.imageUrl[0].downloadURL}
                alt={book?.imageUrl[0].name}
              />
            ) : (
              <p className="bg-gray-300 h-[420px] text-center mb-10 flex justify-center items-center sm:rounded-xl lg:max-w-72">
                <svg
                  className="w-12 h-12 text-gray-200"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  fill="currentColor"
                  viewBox="0 0 640 512"
                >
                  <path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
                </svg>
              </p>
            )}
            <div className="mb-5 lg:ml-0">
              <Button
                item={{ text: "Add to my shelf" }}
                classes="w-full"
                handelClick={handleFavorite}
              />
              <a href={book?.affliate_link} target="_blank" rel="noreferrer">
                <ButtonBg text="Buy on Amazon" classes="w-full" />
              </a>
            </div>
          </div>
          <div className="px-5 lg:pl-10 lg:pt-5 max-w-full lg:w-3/4">
            <h2 className="text-3xl font-semibold text-gray-950 pb-5 sm:text-4xl">
              {book.title}
            </h2>
            <h3 className="mb-1 text-2xl leading-tight text-gray-800 h-12">
              {book.author}
            </h3>
            <div className="flex flex-col sm:flex-row sm:items-center md:justify-between lg:justify-start">
              {book.review_score && (
                <Stars reviewScore={book.review_score} classes="w-10 h-10" />
              )}
              <div className="mt-3 sm:mt-0">
                <span className="text-2xl font-bold text-gray-950 sm:ml-8">
                  {book.review_score}
                </span>
                <span className="text-2xl ml-5 text-gray-400">
                  {book.n_reviews} ratings
                </span>
              </div>
            </div>

            <div className="mt-5">
              <span className="text-xl italic text-gray-400">
                {bookDescription}
              </span>
              {book?.description?.length > 200 && (
                <button
                  onClick={toggleShowMore}
                  className="text-xl italic font-semibold ml-3"
                >
                  {showMore ? "Show less" : "Show more"}
                </button>
              )}
            </div>

            {!keypoints ? (
              <div className="flex">
                <Loading />
              </div>
            ) : (
              <KeypointSwip keypoints={keypoints} />
            )}
          </div>
        </div>
      )}
    </>
  );
};
